import { render, staticRenderFns } from "./ForgotPasswordConfirmation.vue?vue&type=template&id=7900f3b5&scoped=true&"
import script from "./ForgotPasswordConfirmation.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordConfirmation.vue?vue&type=style&index=0&id=7900f3b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7900f3b5",
  null
  
)

export default component.exports